import { SmsDashboardTabEnums } from 'infrastructure/enums';

export const conversationTabs: SmsDashboardTabEnums[] = [
  SmsDashboardTabEnums.RPM,
  SmsDashboardTabEnums.CCM,
  SmsDashboardTabEnums.UNREGISTERED_RPM,
  SmsDashboardTabEnums.UNREGISTERED_CCM,
];
export const registeredConversationTabs = [
  SmsDashboardTabEnums.RPM,
  SmsDashboardTabEnums.CCM,
];
